import React from 'react';
import styled from 'styled-components';

type Props = {
  text: string;
  onClick: () => void;
};
export const AddContactButton: React.FC<Props> = ({ text, onClick }) => (
  <Styled type="button" onClick={onClick}>
    {text}
  </Styled>
);

const Styled = styled.button`
  margin-top: 10px;
  cursor: pointer;
  padding: 14px;
  border: 1px solid #e0b4b4;
  background-color: #fff6f6;
  color: #9f3a38;

  width: 100%;
`;
